export enum StorageTipo {
  LocalStorage = 'localstorage' ,
}
